<template>
  <div>
    <common-hero :title="page.title" :subTitle="page.subTitle" logo="assets/img/DL-logo2022.png"/>
    <article-item v-for="(elt, i) in content" :key="'art' + i" :textElements="elt" />
    <ranking-table v-if="$route.meta.file" :modal="modal" :fields="fields" />
  </div>
</template>

<script>
import CommonHero from '@/components/CommonHero';
import RankingTable from '@/components/common/RankingTable';
import ArticleItem from '@/components/ArticleItem';
import { getPage, getPageById } from '@/api/navItems';
import { translate } from '@/lib/utils';
import _ from 'lodash';

export default {
  components: {
    CommonHero,
    ArticleItem,
    RankingTable
  },
  props: {
    textElements: {
      type: Object,
      default: () => {}
    },
    variant: {
      type: String
    }
  },
  metaInfo() {
    return {
      meta: [
        {
          property: 'og:title',
          vmid: 'og-title',
          content: this.page.title
        },
        {
          property: 'og:description',
          vmid: 'og-description',
          content: this.page.subTitle
        }
      ]
    };
  },
  created() {
    if (this.$route.meta.page)
      getPage(this.$route.meta.page).then(res => {
        this.page = translate(res[0]);
        this.transform();
      });
    else if (this.$route.meta.pageId)
      getPageById(this.$route.meta.pageId).then(res => {
        // Extract modal
        
        let modal = _.filter(res.content, o => o.__component == 'content.modal');
        this.modal = modal.length > 0 ? translate(modal[0]) : {};
        _.remove(res.content, o => o.__component == 'content.modal');
        this.page = translate(res);
        this.transform();
      });
    // then check content elements in page
  },
  data() {
    return {
      content: [],
      page: {},
      modal: {}
    };
  },
  methods: {
    transform() {
      if (this.page.articles.length > 0) {
        this.content = [...this.page.articles];
        null;
      }
      if (this.page.content.length > 0) {
        this.content = [...this.page.content];
        null;
      }
    }
  },
  computed: {
    fields() {
      if (this.$route.meta.fields == 'mainRanking')
        return [
          {
            key: 'UNIVERSITY',
            sortable: true
          },
          { key: 'COUNTRY', sortable: true },
          {
            key: 'RANK',
            class: 'text-center'
          }
        ];
      else if (this.$route.meta.fields == 'hubs')
        return [
          {
            key: 'Hub',
            sortable: true
          },
          {
            key: 'Rank',
            class: 'text-center'
          }
        ];
      else if (this.$route.meta.fields == 'entrepreneur')
        return [
          {
            key: 'UNIVERSITY',
            sortable: true
          },
          {
            key: 'COUNTRY',
            sortable: true
          },
          {
            key: 'RANG',
            label: 'RANK',
            class: 'text-center'
          }
        ];
      else if (this.$route.meta.fields == 'bestofclass')
        return [
          {
            key: 'UNIVERSITY',
            sortable: true
          },
          {
            key: 'COUNTRY',
            sortable: true
          }
        ];
      else return [];
    }
  }
};
</script>

<style lang="scss" scoped>
.blog-text table {
  margin-left: auto;
  margin-right: auto;
  background: black;
}
</style>
<style>
.blog-text table {
  margin-left: auto;
  margin-right: auto;
}

.blog-text table th {
  width: 200px;
  text-align: center;
}
</style>
